<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card elevation="4" light>
          <v-form v-model="valid" @submit.prevent="login">
            <v-container>
              <v-row justify="center">
                <v-col>
                  <h6 class="text-h6">
                    Reset Password
                  </h6>
                  <p class="text-body-1">
                    Please enter your email address.<br>
                    A reset link will be sent if an account exists.
                  </p>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12">
                  <v-text-field
                    v-model="email"
                    :rules="emailRules"
                    label="E-mail"
                    required
                  ></v-text-field>
                </v-col>
      
                <v-col cols="12">
                  <v-btn color="primary" @click="sendResetEmail(email)" :disabled="!valid">
                    Confirm
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import firebase from 'firebase';
  export default {
    data: () => ({
      valid: false,
      email: '',
      emailRules: [
        v => !!v || 'E-mail is required',
        v => /.+@.+/.test(v) || 'E-mail must be valid',
      ],
    }),

    methods: {
      sendResetEmail: function(email) {
        firebase.auth().sendPasswordResetEmail(email).then(() => {
          alert("Please check your email follow the instructions to reset your password.");
          this.$router.push('/')
        }).catch((error) => {
            var errorMessage = error.message;
            alert(errorMessage);
        });
      }
    }
  }
</script>